import React from "react";
import { Link as RouterLink } from "react-router-dom";
import "./Breadcrumbs.css";

/**
 * Breadcrumb trail. Pass `items` as a list of `{ label, to? }`:
 *   <Breadcrumbs items={[{ label: "My Games", to: "/manage" }, { label: "Blanky" }]} />
 *
 * Items with a `to` render as links; the final item always renders as the
 * current (non-link) page. Surface-aware via semantic vars.
 */
const Breadcrumbs = ({ items = [], className = "" }) => (
  <nav className={`gx-crumbs ${className}`} aria-label="Breadcrumb">
    {items.map((item, i) => {
      const isLast = i === items.length - 1;
      const linked = item.to && !isLast;
      return (
        <React.Fragment key={`${item.label}-${i}`}>
          {i > 0 && <span className="gx-crumb-sep" aria-hidden="true">/</span>}
          {linked ? (
            <RouterLink to={item.to} className="gx-crumb">{item.label}</RouterLink>
          ) : (
            <span
              className={`gx-crumb ${isLast ? "is-current" : ""}`}
              aria-current={isLast ? "page" : undefined}
            >
              {item.label}
            </span>
          )}
        </React.Fragment>
      );
    })}
  </nav>
);

export default Breadcrumbs;
